export default {
  form: {
    address: {
      label: 'Osoite',
      placeholder: 'Katu + numero',
    },
    city: {
      label: 'Kaupunki',
      placeholder: 'Kaupunki',
    },
    state: {
      label: 'Osavaltio',
      placeholder: 'Valitse osavaltio',
    },
    country: {
      label: 'Maa',
      placeholder: 'Valitse maa',
    },
    zip_code: {
      label: 'Postinumero',
      placeholder: 'Postinumero',
    },
  },
};
